/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiPayments201, PostApiPayments400, PostApiPayments403, PostApiPayments404, PostApiPayments409, PostApiPayments500, PostApiPaymentsMutationRequest, PostApiPaymentsMutationResponse, PostApiPaymentsQueryParams } from "../entities/PostApiPayments";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsPaymentCreateInputSchema } from "./models/paymentCreateInputSchema";
import { modelsPaymentInitOutputSchema } from "./models/paymentInitOutputSchema";
import { z } from "zod/v4";

export const postApiPaymentsQueryParamsSchema = z.object({
    "branch_id": z.coerce.number().int().min(1).describe("ID филиала")
    }) as unknown as z.ZodType<PostApiPaymentsQueryParams>

/**
 * @description Created
 */
export const postApiPayments201Schema = z.lazy(() => modelsPaymentInitOutputSchema) as unknown as z.ZodType<PostApiPayments201>

/**
 * @description Bad Request
 */
export const postApiPayments400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiPayments400>

/**
 * @description Forbidden
 */
export const postApiPayments403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiPayments403>

/**
 * @description Not Found
 */
export const postApiPayments404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiPayments404>

/**
 * @description Conflict
 */
export const postApiPayments409Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiPayments409>

/**
 * @description Internal Server Error
 */
export const postApiPayments500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiPayments500>

/**
 * @description Группа записей
 */
export const postApiPaymentsMutationRequestSchema = z.lazy(() => modelsPaymentCreateInputSchema) as unknown as z.ZodType<PostApiPaymentsMutationRequest>

export const postApiPaymentsMutationResponseSchema = z.lazy(() => postApiPayments201Schema) as unknown as z.ZodType<PostApiPaymentsMutationResponse>